import { Helmet } from 'react-helmet';
import type { VoidFunctionComponent } from 'react';

import { MANUAL_MALWARE, VULN_ADMIN } from '../../../shared/featureFlags/flagNames';
import { CacheKind } from '../../../shared/InternalTools/cache';
import FeatureFlagRequired from '../generic/Gates/FeatureFlagRequired';
import Text from '../generic/Text';

import BuildLocatorsComponent from './BuildLocatorsComponent';
import FaktoryInfo from './FaktoryInfo';
import InvalidateCacheComponent from './InvalidateCacheComponent';
import ManualMalwareComponent from './ManualMalware';
import OnPremOrgsComponent from './OnPremOrgsComponent';
import OrganizationCard from './OrganizationCard';
import EnrichMetadataComponent from './security/EnrichMetadataComponent';
import RecalculateVulnsComponent from './security/RecalculateVulnsComponent';
import UserCard from './UserCard';

/**
 * Container for the internal tools page.
 */
const InternalToolsPage: VoidFunctionComponent = () => (
  <div className="container margin-top">
    <Helmet title="Internal Tools" />
    <div className="alert">
      Stuff on this page can have catastrophic effects if used incorrectly. Make sure you know what you&apos;re doing.
    </div>
    <div className="internal-tools">
      <OrganizationCard />
      <UserCard />
      <OnPremOrgsComponent />
      <InvalidateCacheComponent cacheKinds={Object.values(CacheKind)} />
      <BuildLocatorsComponent />
      <FeatureFlagRequired flagName={MANUAL_MALWARE}>
        <ManualMalwareComponent />
      </FeatureFlagRequired>
      <FaktoryInfo />
      <FeatureFlagRequired flagName={VULN_ADMIN}>
        <Text.H1>Vulns Tools</Text.H1>
        <div className="internal-tools__vulns">
          <EnrichMetadataComponent type="revision" supportedFetchers={['npm', 'pip', 'mvn']} />
          <RecalculateVulnsComponent />
        </div>
      </FeatureFlagRequired>
    </div>
  </div>
);

export default InternalToolsPage;
